<template>
  <div class="admin_home">
    <PayrollHeader />
    <div class="quickpay">
      <p>
        <router-link to="/decision">&#x2190; Go back</router-link>
      </p>
      <div>
        <p>Fund Your Wallet</p>
        <div>
          <div class="quickpay__form">
            <div>
              <div class="quickpay__form--input">
                <input
                  type="text"
                  placeholder="Enter amount"
                  v-model.trim="formData.amount"
                  @keyup="formatAmount"
                />
                <div>₦</div>
              </div>
              <div
                class="quickpay__form--btn"
                v-if="!loading"
                @click="fundMyWallet()"
              >Fund Your Wallet</div>
              <div class="quickpay__form--btn" v-if="loading">
                <WhiteLoader />
              </div>
            </div>
          </div>
          <div class="quickpay__alert--msg" v-if="lessFund">
            <div class="quickpay__alert--img">
              <img src="./../../../assets/images/warning.png" alt />
            </div>
            <div
              class="quickpay__alert--text"
            >Your wallet balance is insufficient to process this transaction. Kindly fund your wallet</div>
          </div>

          <div class="quickpay__alert--success" v-if="justFunded">
            <div class="quickpay__alert--img">
              <img src="./../../../assets/images/happiness.svg" alt />
            </div>
            <div class="quickpay__alert--text">Yass; Your wallet has been funded</div>
          </div>

          <div class="quickpay__amount">
            <div class="quickpay__amount--balance">
              <span>Wallet Balance</span>
              <p>&#8358;{{ parseInt(currentBalance, 10) | addKoboToValue}}</p>
            </div>
            <div class="quickpay__amount--current">
              <span>Current Payroll Amount</span>
              <p>&#8358;{{ parseInt(payrollBalnace, 10) | addKoboToValue}}</p>
            </div>
            <div class="quickpay__amount--available">
              <span>Transaction Cost</span>
              <p>&#8358;{{ parseInt(transactionCost, 10) | addKoboToValue}}</p>
            </div>
          </div>
          <p v-if="justFunded">Now that your account has been funded, you can pay now</p>
          <div class="quickpay__err">
            <p v-if="serverErr">An error occured. Please try again.</p>
            <p
              v-if="lessFundText"
            >Your don't have enough money to make payment. Please kindly fund your wallet.</p>
            <p v-if="dataFetchError">Unable to fetch wallets data. Please try again.</p>
            <p v-if="dataSaveError">{{dataSaveError}}</p>
            <div v-if="serverErrors">
              <p v-for="(value, name, index) in serverErrors" :key="index">{{value[0]}}</p>
            </div>
          </div>
          <div class="quickpay__btn" @click="payNow" v-if="!payloader">Pay Now</div>
          <div class="quickpay__btn" v-if="payloader">
            <WhiteLoader />
          </div>
          <div class="quickpay__image">
            <img src="./../../../assets/images/beach.png" alt />
          </div>
        </div>
      </div>
    </div>

    <div class="paynow" v-if="modal">
      <div>
        <div>
          <p>
            <span @click="closeModal">
              <font-awesome-icon icon="times" />
            </span>
          </p>
          <div>
            <div class="paynow__image">
              <img src="./../../../assets/images/success.svg" alt="success" />
            </div>
            <span>Payroll Successful</span>
            <div class="paynow__amount">
              <p>
                Total Amount Paid:
                <span>₦{{parseInt(totalCost, 10) | addKoboToValue}}</span>
              </p>
            </div>

            <div class="paynow__btn">
              <div class="paynow__btn--confirm" @click="closeModal">Close</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import * as types from "../../../store/constant";
import PayrollHeader from "../../partials/payrollHeader";
import { addKoboToValue } from "../../../util/filters";
import WhiteLoader from "../../partials/white-loader";

export default {
  name: "QuickpayWallet",
  components: {
    PayrollHeader,
    WhiteLoader
  },
  data() {
    return {
      modal: false,
      previewData: "",
      lessFund: false,
      lessFundErr: false,
      justFunded: false,
      lessFundText: false,
      formData: {
        reference: "",
        mode: "paystack",
        amount: "",
        provider_reference: ""
      },
      dataSaveError: "",
      dataFetchError: false,
      serverErrors: null,
      loading: false,
      currentBalance: null,
      payrollBalnace: null,
      payloader: false,
      serverErr: false,
      totalCost: null,
      companyDetails: null,
      transactionCost: 0
    };
  },
  methods: {
    payNow() {
      this.lessFundErr = false;
      this.serverErr = false;
      this.lessFundText = false;
      this.lessFund = false;

      if (this.payrollBalnace > this.currentBalance) {
        this.lessFundErr = true;
        this.justFunded = false;
        this.lessFundText = true;
        this.lessFund = true;
        return;
      }

      if (Object.keys(this.$store.state.quickpay).length !== 0) {
        const payroll_id = this.previewData.payroll_id;
        const type = "one-off";

        this.payloader = true;

        this.$http
          .post(types.PAYROLL_SUBMIT, {
            payroll_id: payroll_id,
            type: type
          })
          .then(resp => {
            this.totalCost =
              resp.data.data.total_compensations +
              resp.data.data.transaction_cost;

            if (this.totalCost) {
              this.modal = true;
            }
            this.payloader = false;
          })
          .catch(() => {
            this.serverErr = true;
            this.payloader = false;
          });

        return;
      }
      this.$router.push("/decision");
    },
    fundMyWallet() {
      
    },
    generateReference() {
      this.formData.reference = "" + Math.floor(Math.random() * 1000000000 + 1);
    },
    sendToBackend(data) {
      this.loading = true;
      this.$http
        .post(types.COMPANY_WALLET, data)
        .then(resp => {
          this.getCompanyData();

          this.formData = {
            reference: "",
            mode: "paystack",
            amount: "",
            provider_reference: ""
          };
        })
        .catch(err => {
          this.loading = false;
          if (err.response) {
            const message = err.response.data.message;
            if (typeof message === "object") {
              this.serverErrors = message;
            } else {
              this.dataSaveError = message;
            }
          }
        });
    },
    getCompanyData() {
      let user = this.$store.getters.currentAuthUser;
      this.$http
        .get(`${types.COMPANY_GET_API}/${user.employees.company_id}`)
        .then(resp => {
          this.companyDetails = resp.data.data;
          this.getWalletBalance();
        });
    },
    getWalletBalance() {
      this.$http
        .get(`${types.COMPANY_WALLET}/${this.companyDetails.wallet_number}`)
        .then(resp => {
          this.currentBalance = resp.data.data.balance;
          this.previewData.wallet_balance = this.currentBalance;
          this.loading = false;
          this.justFunded = true;

          if (this.payrollBalnace > this.currentBalance) {
            this.lessFundErr = true;
            this.lessFund = true;
          }
        })
        .catch(err => {
          if (err.response) {
            this.dataFetchError = true;
          }
        });
    },
    formatAmount() {
      if (+this.formData.amount.replace(/,/g, "")) {
        this.formData.amount = parseInt(
          this.formData.amount.replace(/,/g, ""),
          10
        )
          .toString()
          .replace(/(\d)(?=(\d{3})+(?!\d))/g, "$1,");
      } else {
        this.formData.amount = this.formData.amount.substring(
          0,
          this.formData.amount.length - 1
        );
      }
    },
    showModal() {
      this.modal = true;
    },
    closeModal() {
      this.modal = false;
      this.$router.push("/decision");
    }
  },
  created() {
    if (Object.keys(this.$store.state.quickpay).length !== 0) {
      this.previewData = this.$store.state.quickpay;

      this.transactionCost = this.previewData.transaction_cost.total;

      this.currentBalance = this.previewData.wallet_balance;
      this.payrollBalnace = this.previewData.total_payroll;

      if (this.payrollBalnace > this.currentBalance) {
        this.lessFund = true;
      }
      return;
    }
    this.$router.push("/decision");
  },
  filters: {
    addKoboToValue
  }
};
</script>
<style lang="scss" scoped>
.quickpay {
  background-color: #fbfafa;
  padding-top: 20px;
  padding-bottom: 100px;
  padding-left: 50px;
  padding-right: 50px;
  min-height: 700px;

  @media (max-width: 800px) {
    padding-left: 20px;
    padding-right: 20px;
  }

  @media (max-width: 500px) {
    padding-left: 10px;
    padding-right: 10px;
  }

  > p {
    font-size: 12px;
    font-weight: 300;
    font-style: normal;
    font-stretch: normal;
    line-height: 1.28;
    letter-spacing: normal;
    text-align: left;

    > a {
      color: #707070;
      text-decoration: none;
    }
  }

  > div {
    > p {
      font-size: 25px;
      font-weight: 600;
      font-style: normal;
      font-stretch: normal;
      line-height: 1.17;
      letter-spacing: normal;
      text-align: left;
      color: #000000;
    }

    > div {
      border-top: 1px solid #caced5;

      > .quickpay__form {
        overflow: hidden;
        margin: 20px 0;

        > div {
          width: 300px;
          float: right;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: center;
          align-content: center;

          > .quickpay__form--input {
            width: 60%;
            height: 40px;
            border: solid 1px #caced5;
            background-color: #ffffff;
            overflow: hidden;
            position: relative;

            > input {
              width: 100%;
              height: 40px;
              background-color: #fff;
              border: 0;
              outline: 0;
              padding-left: 42px;
              padding-right: 5px;
              font-size: 12px;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.16;
              letter-spacing: normal;
              color: #000000;
            }

            > div {
              position: absolute;
              top: 0;
              left: 0;
              width: 40px;
              height: 40px;
              border-right: solid 1px #caced5;
              background-color: #fbfafa;
              display: flex;
              flex-direction: row;
              flex-wrap: nowrap;
              align-items: center;
              justify-content: center;
              align-content: center;
              font-size: 16px;
              font-weight: normal;
              font-style: normal;
              font-stretch: normal;
              line-height: 1.16;
              letter-spacing: normal;
              color: #000000;
            }
          }

          > .quickpay__form--btn {
            width: 40%;
            height: 40px;
            border-radius: 2px;
            background-color: #5099de;
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            display: flex;
            flex-direction: row;
            flex-wrap: nowrap;
            align-items: center;
            justify-content: center;
            align-content: center;
            cursor: pointer;
          }
        }
      }

      > .quickpay__alert--msg {
        max-width: 600px;
        margin: 30px auto 50px auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 #fff9f0;
        border: solid 2px #ffe7bd;
        background-color: #fff9f0;
        padding: 10px 30px;

        > .quickpay__alert--img {
          width: 50px;
          height: 40px;

          > img {
            width: 40px;
          }
        }

        > .quickpay__alert--text {
          font-size: 12px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }
      }

      > .quickpay__alert--success {
        max-width: 300px;
        margin: 30px auto 50px auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        border-radius: 5px;
        box-shadow: 0 2px 4px 0 #fff9f0;
        border: solid 2px #5099de;
        background-color: rgba(237, 249, 247, 0.5);
        padding: 10px 30px;

        > .quickpay__alert--img {
          width: 50px;

          > img {
            width: 25px;
          }
        }

        > .quickpay__alert--text {
          font-size: 12px;
          font-weight: normal;
          font-style: normal;
          font-stretch: normal;
          line-height: 1.2;
          letter-spacing: normal;
          text-align: left;
          color: #000000;
        }
      }

      > .quickpay__amount {
        max-width: 700px;
        padding: 10px 0;
        border-radius: 2px;
        box-shadow: 0 2px 4px 0 rgba(0, 0, 0, 0.1);
        background-color: #ffffff;
        margin: 30px auto 0 auto;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
        text-align: center;

        > .quickpay__amount--balance {
          width: 33.3333333%;
          padding: 10px 0;
          border-right: 1px dashed rgba(0, 0, 0, 0.2);

          > span {
            font-size: 14px;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
          }

          > p {
            font-size: 25px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.18;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            margin-top: 20px;
          }
        }

        > .quickpay__amount--current {
          padding: 10px 0;
          width: 33.3333333%;

          > span {
            font-size: 14px;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
          }

          > p {
            font-size: 25px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.18;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            margin-top: 20px;
          }
        }

        > .quickpay__amount--available {
          padding: 10px 0;
          width: 33.3333333%;
          border-left: 1px dashed rgba(0, 0, 0, 0.2);

          > span {
            font-size: 14px;
            font-weight: 200;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
          }

          > p {
            font-size: 25px;
            font-weight: 600;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.18;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            margin-top: 20px;
          }
        }
      }

      > p {
        font-size: 16px;
        font-weight: 500;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.43;
        letter-spacing: normal;
        text-align: center;
        color: #000000;
        margin: 30px 0;
      }

      .quickpay__err {
        margin: 15px 0;

        p {
          margin: 0;
          text-align: center;
          text-align: center;
          color: red;
          font-size: 0.938vw;
          font-style: italic;
        }

        > div {
          padding-bottom: 10px;
          text-align: center;
          text-align: center;
          color: red;
          font-size: 0.938vw;
          font-style: italic;
        }
      }

      > .quickpay__btn {
        width: 100px;
        height: 40px;
        border-radius: 3px;
        background-color: #5099de;
        font-size: 12px;
        font-weight: normal;
        font-style: normal;
        font-stretch: normal;
        line-height: 1.22;
        letter-spacing: normal;
        text-align: center;
        color: #ffffff;
        margin: 0 auto;
        cursor: pointer;
        display: flex;
        flex-direction: row;
        flex-wrap: nowrap;
        align-items: center;
        justify-content: center;
        align-content: center;
      }

      > .quickpay__image {
        width: 400px;
        margin: 50px auto;
        opacity: 0.4;
      }
    }
  }
}

.paynow {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.8);
  z-index: 9999999;
  overflow: auto;

  > div {
    max-width: 500px;
    padding: 0 10px;
    margin: 50px auto;

    > div {
      background-color: #fff;
      padding: 20px;
      text-align: center;

      > p {
        margin-bottom: 5px;
        text-align: right;

        > span {
          cursor: pointer;
          color: #000;
        }
      }

      > div {
        > .paynow__image {
          width: 40px;
          height: 40px;
          margin: 0 auto 30px auto;
        }

        // > span {
        //   font-size: 16px;
        //   font-weight: normal;
        //   font-style: normal;
        //   font-stretch: normal;
        //   line-height: 1.88;
        //   letter-spacing: normal;
        //   text-align: center;
        //   color: #000000;
        // }

        > .paynow__amount {
          margin-top: 10px;

          > p {
            font-size: 14px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.17;
            letter-spacing: normal;
            text-align: center;
            color: #5099de;

            > span {
              font-size: 20px;
              font-weight: 600;
              font-style: normal;
              font-stretch: normal;
              line-height: 1;
              letter-spacing: normal;
              text-align: center;
              color: #000000;
              margin-top: 10px;
            }
          }
        }

        // > p {
        //   font-size: 14px;
        //   font-weight: 200;
        //   font-style: normal;
        //   font-stretch: normal;
        //   line-height: 2.5;
        //   letter-spacing: normal;
        //   text-align: center;
        //   color: #000000;
        // }

        > .paynow__btn {
          width: 300px;
          margin: 10px auto;
          display: flex;
          flex-direction: row;
          flex-wrap: nowrap;
          align-items: center;
          justify-content: space-between;
          align-content: center;

          > .paynow__btn--pay {
            width: 45%;
            min-width: 100px;
            height: 40px;
            border-radius: 5px;
            background-color: #5099de;
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            padding-top: 12px;
            cursor: pointer;
          }

          > .paynow__btn--cancel {
            width: 45%;
            height: 40px;
            min-width: 100px;
            border-radius: 5px;
            background-color: #dcdcdc;
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #000000;
            padding-top: 12px;
            cursor: pointer;
          }

          > .paynow__btn--confirm {
            width: 100px;
            min-width: 100px;
            height: 40px;
            border-radius: 5px;
            background-color: #5099de;
            font-size: 12px;
            font-weight: normal;
            font-style: normal;
            font-stretch: normal;
            line-height: 1.2;
            letter-spacing: normal;
            text-align: center;
            color: #ffffff;
            padding-top: 12px;
            cursor: pointer;
            margin: 0 auto;
          }
        }
      }
    }
  }
}
</style>
